import styles from './style.module.styl'

export const AuthContent = ({title, children, extra}) =>
  <div className={styles.authContent} >
    <h2 className={styles.title} >{title}</h2>
    <div className={styles.main} >
      {children}
    </div>
    <div className={styles.extra}>
      {extra}
    </div>
  </div>
